import styled from 'styled-components';

import IconMinus from 'components/icons/minus';

const MinusIcon = styled(IconMinus)`
  width: 10px;
  display: inline-block;
  margin: auto;
  fill: ${Styles.color.primary};
`;

export default MinusIcon;
